import RequestSpin from "slotworks/state-machine/standard/states/request-spin";
import { UnlockSymbols } from "commands/symbols-commands";
import Components from "slotworks/components/components";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";

export default class G288RequestSpin extends RequestSpin {

    public onEnter(cascadeSkip?: boolean) {
        UnlockSymbols(Components.matrix.getGridSymbols());
        super.onEnter(cascadeSkip);
    }

    public onExit() {
        if(!campaignsModel.isFreespinsActive()){
            smartButton.setFlag(SmartButtonFlag.AWAITING_RESPONSE, false);
        }
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/request-spin.ts